import React, { createContext, useState, useContext, useEffect } from "react";
const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
 const allProducts = {
  Kaspersky: [
    {
      id: "201",
      name: "Kaspersky Essential Security",
      desc:
        "A lightweight Kaspersky plan built for everyday protection, offering core threat detection and automatic updates for supported Windows systems.",
      price: "69.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611901/kaspersky_antivirus_box_tc2qeo_cltqlk.webp",
      route: "/kaspersky/kaspersky-essential-security",
      license: "Up to 3 Devices / 1 Year",
      compatibility: ["Windows"],
      highlights: [
        "Real-time protection against common malware and threats",
        "Automatic security definition updates",
        "Quick, full, and custom scan options",
        "Security activity logs for review"
      ],
      additionalFeatures: [
        "Silent mode to reduce notifications during work or gaming",
        "Basic application monitoring"
      ],
      idealFor:
        "Users seeking simple and efficient protection for a small number of Windows PCs",
      support:
        "Customer support provided directly by Kaspersky as per subscription terms"
    },
    {
      id: "202",
      name: "Kaspersky Internet Security",
      desc:
        "An expanded Kaspersky plan that combines core device protection with tools designed to support safer browsing, payments, and online privacy.",
      price: "79.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764612655/kaspersky_total_security_ztnofw_vyuw2h.png",
      route: "/kaspersky/kaspersky-internet-care",
      license: "Up to 3 Devices / 1 Year",
      compatibility: ["Windows", "macOS", "Android", "iOS"],
      highlights: [
        "Web protection for potentially unsafe or misleading sites",
        "Extra safeguards for online payments",
        "Camera and microphone permission alerts",
        "Single license usable across supported platforms"
      ],
      additionalFeatures: [
        "Virtual keyboard for secure form entry",
        "Basic anti-tracking tools",
        "Parental controls on supported devices"
      ],
      idealFor:
        "Users who shop, bank, and browse online regularly and want added security layers",
      support:
        "Customer support provided directly by Kaspersky as per subscription terms"
    },
    {
      id: "203",
      name: "Kaspersky Total Security",
      desc:
        "A comprehensive Kaspersky solution that combines security, password management, backup features, and family tools in one subscription.",
      price: "99.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764612654/kaspersky_total_security_2_fqsarp_qijiso.png",
      route: "/kaspersky/kaspersky-complete-protection",
      license: "Up to 5 Devices / 1 Year",
      compatibility: ["Windows", "macOS", "Android", "iOS"],
      highlights: [
        "Password manager with cross-device sync",
        "Backup tools for important files (where available)",
        "Parental monitoring features on compatible platforms",
        "System health and security recommendations"
      ],
      additionalFeatures: [
        "USB and external drive scanning",
        "Central privacy settings dashboard"
      ],
      idealFor:
        "Families and households looking for an all-in-one security and privacy package",
      support:
        "Customer support provided directly by Kaspersky as per subscription terms"
    },
    {
      id: "204",
      name: "Kaspersky Security Cloud (Personal)",
      desc:
        "A cloud-based Kaspersky plan that adapts protection settings and recommendations based on user behavior and connected devices.",
      price: "109.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764612653/kaspersky_security_cloud_p5vhrh_l4rrqt.png",
      route: "/kaspersky/kaspersky-smart-security-cloud",
      license: "Up to 10 Devices / 1 Year",
      compatibility: ["Windows", "macOS", "Android", "iOS"],
      highlights: [
        "Central dashboard for managing multiple devices",
        "Adaptive security recommendations",
        "Account and sign-in monitoring alerts (where available)",
        "Wi-Fi and network safety notifications"
      ],
      additionalFeatures: [
        "VPN activation on public networks (plan limits apply)",
        "Device health reminders",
        "Family device sharing controls (plan dependent)"
      ],
      idealFor:
        "Users with many devices who prefer cloud-based control and insights",
      support:
        "Customer support provided directly by Kaspersky as per subscription terms"
    }
  ],

  Avast: [
    {
      id: "101",
      name: "Avast Pro Antivirus",
      desc:
        "An Avast plan for single-device protection that includes core scanning plus tools like sandbox testing and Wi-Fi inspection.",
      price: "69.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613034/avast_pro_antivirus_zuj103_ne3qmz.png",
      route: "/avast/avast-pro-security",
      license: "1 Device / 1 Year",
      compatibility: ["Windows", "Mac"],
      highlights: [
        "Real-time and scheduled malware scans",
        "Sandbox space to open suspicious files safely",
        "Wi-Fi inspector for basic network checks",
        "Do Not Disturb mode for fewer interruptions"
      ],
      idealFor:
        "People protecting one primary computer who also want a safe way to test unknown files",
      support:
        "Customer support provided directly by Avast under subscription terms"
    },
    {
      id: "102",
      name: "Avast Premium Security (Multi-Device)",
      desc:
        "A multi-device Avast subscription that extends protection across major platforms with added privacy and payment-focused tools.",
      price: "89.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613032/avast_premium_security_c9ivar_sskoen.png",
      route: "/avast/avast-premium-care",
      license: "Up to 10 Devices / 1 Year",
      compatibility: ["Windows", "Mac", "Android", "iOS"],
      highlights: [
        "Protection for sensitive files and folders (where supported)",
        "Webcam and microphone access notifications",
        "Browser mode designed for payments and banking",
        "Alerts for certain suspicious behaviors or exposure types"
      ],
      idealFor:
        "Homes and remote workers using multiple devices who want extra privacy and payment protections",
      support:
        "Customer support provided directly by Avast under subscription terms"
    },
    {
      id: "103",
      name: "Avast Ultimate",
      desc:
        "A bundled Avast package that combines security with VPN, password management, and performance utilities under one subscription.",
      price: "109.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613033/avast_ultimate_lkxryb_gpd498.png",
      route: "/avast/avast-ultimate",
      license: "Up to 10 Devices / 1 Year",
      compatibility: ["Windows", "Mac", "Android", "iOS"],
      highlights: [
        "Security suite with an included VPN option (plan limits may apply)",
        "Password management features for storing logins",
        "Cleanup tools for storage and startup items",
        "Browser cleanup utilities for add-ons and toolbars"
      ],
      idealFor:
        "Users who prefer one subscription that covers security, privacy, and device maintenance tools",
      support:
        "Customer support provided directly by Avast under subscription terms"
    },
    {
      id: "104",
      name: "Avast Cleanup Premium",
      desc:
        "A performance-focused Avast utility designed to reduce clutter, manage startup items, and support smoother everyday use.",
      price: "79.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613030/avast_cleanup_premium_t8kref_uvxrzo.png",
      route: "/avast/avast-cleanup-premium",
      license: "Unlimited PCs / 1 Year",
      compatibility: ["Windows", "Mac"],
      highlights: [
        "Removes temporary files, cache, and leftover data",
        "Startup manager to review boot-time apps",
        "Recurring maintenance schedules for cleanups",
        "Performance dashboard with suggestions"
      ],
      idealFor:
        "People who want guided, recurring cleanups—especially on older or heavily used systems",
      support:
        "Customer support provided directly by Avast under subscription terms"
    }
  ],

  McAfee: [
    {
      id: "001",
      name: "McAfee Antivirus Basic",
      desc:
        "A simple McAfee plan focused on core malware scanning, safe browsing indicators, and automatic protection updates.",
      price: "69.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764612709/mcafee_antivirus_basic_bszyzo_q88u8p.png",
      route: "/mcafee/mcafee-essential-security",
      license: "1 Device / 1 Year",
      compatibility: ["Windows", "Mac"],
      highlights: [
        "Real-time and scheduled scans for common threats",
        "Website and email link risk indicators",
        "Automatic engine and definition updates"
      ],
      idealFor:
        "New users who want straightforward McAfee protection for one computer",
      support:
        "Customer support provided directly by McAfee according to plan terms"
    },
    {
      id: "002",
      name: "McAfee Antivirus Plus (Multi-Device)",
      desc:
        "A McAfee subscription built for multiple devices, adding centralized status checks plus basic network and performance tools.",
      price: "74.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764612708/mcafee_antivirus_plus_fkldky_rpijzq.png",
      route: "/mcafee/mcafee-multi-device-plus",
      license: "5 Devices / 1 Year",
      compatibility: ["Windows", "Mac", "Android", "iOS"],
      highlights: [
        "Coverage for multiple desktops and mobile devices",
        "Device and network overview tools",
        "Guided scans for common threat categories",
        "Performance utilities to help reduce background load"
      ],
      idealFor:
        "Households or home offices that need one subscription to protect several devices",
      support:
        "Customer support provided directly by McAfee according to plan terms"
    },
    {
      id: "003",
      name: "McAfee Internet Security",
      desc:
        "A mid-tier McAfee suite that adds password management and extra privacy-focused options for regular online activity.",
      price: "79.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764612756/mcafee_internet_security_bznxcf_ubourl.png",
      route: "/mcafee/mcafee-internet-care-suite",
      license: "3 Devices / 1 Year",
      compatibility: ["Windows", "Mac", "Android"],
      highlights: [
        "Password manager for secure storage and autofill",
        "Privacy monitoring features (where offered)",
        "Parental controls on supported platforms",
        "Browser tools to help flag risky sites and links"
      ],
      idealFor:
        "Users who want password tools and added privacy layers across a few devices",
      support:
        "Customer support provided directly by McAfee according to plan terms"
    },
    {
      id: "004",
      name: "McAfee Total Protection",
      desc:
        "A broader McAfee bundle that combines device security with privacy utilities, monitoring tools, and coverage across multiple platforms.",
      price: "109.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764612837/mcafee_total_protection_premium_gzwapo_igdtu5.png",
      route: "/mcafee/mcafee-total-protection-ultimate",
      license: "Multiple Devices / 1 Year",
      compatibility: ["Windows", "Mac", "Android", "iOS"],
      highlights: [
        "VPN option for private browsing (plan limits may apply)",
        "Identity and data monitoring alerts (region dependent)",
        "Encrypted storage vault for sensitive files",
        "Central dashboard to review device status"
      ],
      idealFor:
        "Families and frequent travelers who want wider protection plus privacy and monitoring tools",
      support:
        "Customer support provided directly by McAfee according to plan terms"
    }
  ],

  Norton: [
    {
      id: "301",
      name: "Norton AntiVirus Plus",
      desc:
        "A single-device plan that combines core malware protection with a firewall, password storage, and limited cloud backup where supported.",
      price: "69.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613027/norton_icon_wjwpwc_nfcjap.png",
      route: "/norton/norton-security-plus",
      license: "1 Device / 1 Year",
      compatibility: ["Windows", "Mac"],
      highlights: [
        "Configurable scan schedules and real-time protection",
        "Password manager for login storage",
        "Smart Firewall to monitor network activity",
        "Cloud backup on supported platforms (storage varies)"
      ],
      idealFor:
        "Users protecting one primary PC or Mac who want security plus password and firewall tools",
      support:
        "Customer support provided directly by under subscription terms"
    },
    {
      id: "302",
      name: "Norton 360 Standard",
      desc:
        "A 360 plan that adds VPN and monitoring features alongside security, designed for one main device across supported platforms.",
      price: "79.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613026/norton_360_standard_ozkppo_sufuok.png",
      route: "/norton/norton-360-standard",
      license: "1 Device / 1 Year",
      compatibility: ["Windows", "Mac", "Android", "iOS"],
      highlights: [
        "VPN for encrypted connections (limits may apply)",
        "Cloud backup allocation based on plan (where supported)",
        "Account/credential monitoring alerts (where available)",
        "Browser tools for safer links and tracking reduction"
      ],
      idealFor:
        "Solo users and remote workers who want security plus VPN features for one device",
      support:
        "Customer support provided directly by  under subscription terms"
    },
    {
      id: "303",
      name: "Norton 360 Deluxe",
      desc:
        "A  360 upgrade that covers multiple devices and includes family features and increased backup capacity compared to lower tiers.",
      price: "99.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613026/norton_antivirus_deluxe_uch56e_iipgyj.png",
      route: "/norton/norton-360-deluxe",
      license: "5 Devices / 1 Year",
      compatibility: ["Windows", "Mac", "Android", "iOS"],
      highlights: [
        "Security and VPN for multiple devices (limits may apply)",
        "Larger cloud backup compared to Standard (where supported)",
        "Parental controls for family devices (where supported)",
        "Privacy dashboard for key protections"
      ],
      idealFor:
        "Families and shared households that want a single  subscription for several devices",
      support:
        "Customer support provided directly by  under subscription terms"
    },
    {
      id: "304",
      name: "Norton 360 Premium",
      desc:
        "A higher-capacity  360 plan that increases device coverage and cloud backup while keeping privacy and family-focused tools.",
      price: "119.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613024/norton_360_premium_widqoc_fwdu0g.png",
      route: "/norton/norton-360-premium",
      license: "10 Devices / 1 Year",
      compatibility: ["Windows", "Mac", "Android", "iOS"],
      highlights: [
        "Coverage for more devices under one subscription",
        "Increased cloud backup vs lower tiers (where supported)",
        "Parental and privacy tools (availability varies)",
        "Extra performance utilities on supported systems"
      ],
      idealFor:
        "Larger families and home offices with many active devices to protect",
      support:
        "Customer support provided directly by  under subscription terms"
    }
  ],

  AVG: [
    {
      id: "401",
      name: "AVG Internet Security",
      desc:
        "An AVG suite for everyday online activity that combines protection tools for web browsing, email, and firewall management.",
      price: "79.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611898/avg_internet_security_lyg2rb_pqlfny.png",
      route: "/avg/avg-internet-security",
      license: "Up to 10 Devices / 1 Year",
      compatibility: ["Windows", "Mac", "Android"],
      highlights: [
        "Web and download protection for common risks",
        "Smart Firewall to manage app connections",
        "Email attachment and link checks",
        "Webcam prompt options on supported systems"
      ],
      idealFor:
        "Homes and small teams that want AVG handling day-to-day web and email security",
      support:
        "Customer support provided directly by AVG in line with subscription terms"
    },
    {
      id: "402",
      name: "AVG Ultimate",
      desc:
        "An all-in-one AVG bundle that brings together security, VPN access, and tune-up utilities for multiple devices.",
      price: "99.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611899/avg_ultimate_bg_cflsz6_vbqgxx.png",
      route: "/avg/avg-ultimate",
      license: "Up to 10 Devices / 1 Year",
      compatibility: ["Windows", "Mac", "Android", "iOS"],
      highlights: [
        "Device health monitoring with suggestions",
        "VPN for encrypted browsing (plan limits may apply)",
        "Tune-up tools for speed and storage maintenance",
        "App and driver update helpers (availability varies)"
      ],
      idealFor:
        "Multi-device users who want security plus privacy and performance tools in one plan",
      support:
        "Customer support provided directly by AVG in line with subscription terms"
    },
    {
      id: "403",
      name: "AVG Secure VPN",
      desc:
        "A standalone AVG VPN subscription focused on encrypting traffic and simplifying safe connections on common platforms.",
      price: "79.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611900/avg_secure_vpn_docu1i_w43dg7.png",
      route: "/avg/avg-secure-vpn",
      license: "Up to 5 Devices / 1 Year",
      compatibility: ["Windows", "Mac", "Android", "iOS"],
      highlights: [
        "Encrypted tunnel for public or shared Wi-Fi use",
        "Server location choices in supported regions",
        "Auto-connect options for open networks"
      ],
      idealFor:
        "Travelers and café/airport Wi-Fi users who want an AVG-branded VPN option",
      support:
        "Customer support provided directly by AVG in line with subscription terms"
    },
    {
      id: "404",
      name: "AVG AntiTrack",
      desc:
        "A privacy utility designed to reduce browser fingerprinting signals and limit common tracking methods used across websites.",
      price: "69.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611898/avg_antitrack_aumzve_crjxat.png",
      route: "/avg/avg-antitrack",
      license: "1 Device / 1 Year",
      compatibility: ["Windows", "Mac"],
      highlights: [
        "Helps reduce browser fingerprinting techniques",
        "Blocks many common tracking scripts and cookies",
        "Reports on blocked activity and attempts",
        "Cookie and browsing data management tools"
      ],
      idealFor:
        "Privacy-focused users who want more control over tracking on their main computer",
      support:
        "Customer support provided directly by AVG in line with subscription terms"
    }
  ],

  Bitdefender: [
    {
      id: "501",
      name: "Bitdefender Antivirus Plus",
      desc:
        "A Windows-focused Bitdefender plan offering core protection along with select privacy features and a VPN component based on plan limits.",
      price: "69.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611899/bitdefender_antivirus_plus_wgbelm_vikxmo.png",
      route: "/bitdefender/bitdefender-antivirus-plus",
      license: "Up to 3 Devices / 1 Year",
      compatibility: ["Windows"],
      highlights: [
        "Real-time and on-demand scans for files and apps",
        "Web protection tools to reduce risky browsing",
        "Patch and update recommendations",
        "VPN component with plan-based data allowance"
      ],
      idealFor:
        "Users with a few Windows PCs who want Bitdefender protection plus light privacy add-ons",
      support:
        "Customer support provided directly by Bitdefender according to plan terms"
    },
    {
      id: "502",
      name: "Bitdefender Internet Security",
      desc:
        "A Windows-only Bitdefender suite that adds firewall control, privacy permissions, and parental tools alongside its protection engine.",
      price: "79.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611900/bitdefender_in_security_jpt7xp_bkvmtj.png",
      route: "/bitdefender/bitdefender-internet-security",
      license: "Up to 3 Devices / 1 Year",
      compatibility: ["Windows"],
      highlights: [
        "Camera and microphone privacy controls",
        "Firewall for managing app and network access",
        "Parental tools on supported Windows versions",
        "VPN component with plan-based data limits"
      ],
      idealFor:
        "Windows users who want firewall and privacy controls in addition to core protection",
      support:
        "Customer support provided directly by Bitdefender according to plan terms"
    },
    {
      id: "503",
      name: "Bitdefender Total Security",
      desc:
        "A cross-platform Bitdefender plan combining security and privacy tools with performance profiles for multiple device types.",
      price: "99.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611901/bitdefender_total_security_dvxs6q_ehzl3m.png",
      route: "/bitdefender/bitdefender-total-security",
      license: "Up to 5 Devices / 1 Year",
      compatibility: ["Windows", "macOS", "iOS", "Android"],
      highlights: [
        "Single subscription across major platforms",
        "Locate, lock, or wipe tools for missing devices (where supported)",
        "Profiles for performance and battery optimization",
        "Secure file deletion tools on supported systems",
        "VPN component with plan-based allowance"
      ],
      idealFor:
        "Households using a mix of computers and mobile devices who want one Bitdefender license for all",
      support:
        "Customer support provided directly by Bitdefender according to plan terms"
    },
    {
      id: "504",
      name: "Bitdefender Family Pack",
      desc:
        "A higher device-limit Bitdefender plan intended for families, with centralized management and parental controls depending on platform support.",
      price: "119.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764611899/bitdefender_family_fpj1d3_lbhnfg.png",
      route: "/bitdefender/bitdefender-family-pack",
      license: "Up to 15 Devices / 1 Year",
      compatibility: ["Windows", "macOS", "iOS", "Android"],
      highlights: [
        "Large device coverage under one account",
        "Screen-time and content filters (feature set varies)",
        "VPN usage based on included plan limits",
        "Central console to manage family devices"
      ],
      idealFor:
        "Large families or shared homes with many devices needing centralized management",
      support:
        "Customer support provided directly by Bitdefender according to plan terms"
    }
  ],

  TotalAV: [
    {
      id: "601",
      name: "TotalAV Antivirus Pro",
      desc:
        "A core TotalAV plan offering everyday threat protection with scanning, web filtering, and basic cleanup utilities for supported devices.",
      price: "69.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613028/totalav_pro_antivirus_hqveuc_xeyg6u.svg",
      route: "/totalav/totalav-pro-antivirus",
      license: "Up to 3 Devices / 1 Year",
      compatibility: ["Windows", "macOS", "Android", "iOS"],
      highlights: [
        "Real-time and scheduled scans for files and apps",
        "Web shield to help identify risky links",
        "Junk file and cache cleanup tools"
      ],
      idealFor:
        "Everyday users who want one license for a few devices with light cleanup features included",
      support:
        "Customer support provided directly by TotalAV according to subscription terms"
    },
    {
      id: "602",
      name: "TotalAV Internet Security",
      desc:
        "A step-up TotalAV plan that adds VPN access and privacy tools, plus startup optimization features for smoother daily use.",
      price: "79.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613028/totalav_internet_security_vector_pdxvla_gab1qn.svg",
      route: "/totalav/totalav-internet-security",
      license: "Up to 5 Devices / 1 Year",
      compatibility: ["Windows", "macOS", "Android", "iOS"],
      highlights: [
        "VPN for encrypted browsing on supported devices (plan limits apply)",
        "Ad and tracker control tools (availability varies)",
        "Checks for risky downloads and files",
        "Startup and performance utilities"
      ],
      idealFor:
        "Users who want security plus privacy tools for devices used across multiple networks",
      support:
        "Customer support provided directly by TotalAV according to subscription terms"
    },
    {
      id: "603",
      name: "TotalAV Total Security",
      desc:
        "A flagship TotalAV bundle combining security, VPN, password management, and monitoring features into a centralized dashboard.",
      price: "99.99",
      category: "standard",
      img:
        "https://res.cloudinary.com/dppalz0f4/image/upload/v1764613029/totalav_total_security_xnxsqp_u7twfx.svg",
      route: "/totalav/totalav-total-security",
      license: "Up to 6 Devices / 1 Year",
      compatibility: ["Windows", "macOS", "Android", "iOS"],
      highlights: [
        "Password manager for secure login storage and autofill",
        "VPN access for safer connections on public networks (limits may apply)",
        "Identity and account alerts where available",
        "Central device console to review protection status"
      ],
      idealFor:
        "Families and professionals who want an all-in-one package with VPN and password tools included",
      support:
        "Customer support provided directly by TotalAV according to subscription terms"
    }
  ]
};

  const [products] = useState(allProducts);

  const getDataFromStorage = (key, defaultValue) => {
    try {
      const item = localStorage.getItem(key);
      const parsedItem = item ? JSON.parse(item) : defaultValue;

      if (key === "antivCart" && !Array.isArray(parsedItem)) {
        console.error(`Data from localStorage for ${key} is not an array`);
        return defaultValue;
      }

      return parsedItem;
    } catch (error) {
      console.error(`Error parsing ${key} from localStorage`, error);
      return defaultValue;
    }
  };

  const [cart, setCart] = useState(() => getDataFromStorage("antivCart", []));
  const [productToShow, setProductToShow] = useState(() =>
    getDataFromStorage("selectedProduct", "")
  );
  const [selectedAntiv, setSelectedAntiv] = useState(() =>
    getDataFromStorage("selectedCategory", "")
  );
  const [catenav, setCatenav] = useState(false);

  useEffect(() => {
    localStorage.setItem("selectedProduct", JSON.stringify(productToShow));
  }, [productToShow]);

  useEffect(() => {
    localStorage.setItem("antivCart", JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    localStorage.setItem("selectedCategory", JSON.stringify(selectedAntiv));
  }, [selectedAntiv]);

  return (
    <ProductContext.Provider
      value={{
        catenav,
        setCatenav,
        products,
        cart,
        setCart,
        productToShow,
        setProductToShow,
        selectedAntiv,
        setSelectedAntiv
      }}
    >
      {children}
    </ProductContext.Provider>
  );
};

export const useProduct = () => useContext(ProductContext);
